<template>
  <div class="column pt-0">
    <h2 class="has-text-weight-semibold is-size-5 mb-4">Список серийных номеров</h2>
    <BaseTable
      :data="serialNumbers"
      :columns="columns"
      :loading="isLoading"
      :total="total"
      :per-page="perPage"
      :current-page="currentPage"
      @change="fetchSerialNumbers"
    />
  </div>
</template>

<script>
import BaseTable from "@/components/Base/Table";

export default {
  name: "SerialNumbersList",
  components: { BaseTable },
  data() {
    return {
      total: 0,
      serialNumbers: [],
      isLoading: true,
      currentPage: 1,
      perPage: 15,
      columns: [
        {
          field: "id",
          label: "ID",
          width: "40",
          numeric: true,
        },
        {
          field: "code",
          label: "Серийный номер",
          centered: true,
        },
        {
          field: "agent.device_name",
          label: "Агент",
        },
        {
          field: "activated_at",
          label: "Дата активации",
        },
        {
          field: "created_at",
          label: "Дата создания",
        },
      ],
    };
  },
  mounted() {
    this.fetchSerialNumbers();
  },
  methods: {
    async fetchSerialNumbers(page) {
      this.currentPage = page || 1;
      this.isLoading = true;
      try {
        const { data } = await this.$axios.get(
          `admin/serial-numbers/paginate/${(this.currentPage - 1) * 15}/${this.perPage}`
        );
        this.serialNumbers = data?.data || [];
        this.total = data?.count;
      } catch (e) {
        throw new Error(e);
      }
      this.isLoading = false;
    },

  },
};
</script>

<style scoped>
</style>
